import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { api } from '../api/client';

export default function CambiarPassword() {
  const nav = useNavigate();
  const [actual,    setActual]    = useState('');
  const [nuevo,     setNuevo]     = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [showA,     setShowA]     = useState(false);
  const [showN,     setShowN]     = useState(false);
  const [loading,   setLoading]   = useState(false);
  const [err,       setErr]       = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!actual)          return setErr('Ingresá tu contraseña actual');
    if (nuevo.length < 6) return setErr('La nueva contraseña debe tener al menos 6 caracteres');
    if (nuevo !== confirmar) return setErr('Las contraseñas no coinciden');
    setLoading(true);
    setErr(null);
    try {
      await api('/auth?action=cambiar_password', {
        method: 'POST',
        body: JSON.stringify({ password_actual: actual, password_nuevo: nuevo }),
      });
      nav('/perfil', { replace: true });
    } catch (e: any) {
      setErr(e.message || 'Error al cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <TopBar title="Cambiar contraseña" back />
      <main className="max-w-sm mx-auto px-5 py-6 space-y-4">

        <p className="text-sm text-gray-500">
          Ingresá tu contraseña actual y luego la nueva contraseña dos veces para confirmar.
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <Field
            label="Contraseña actual"
            value={actual}
            show={showA}
            onChange={setActual}
            onToggle={() => setShowA((v) => !v)}
          />
          <Field
            label="Nueva contraseña"
            value={nuevo}
            show={showN}
            onChange={setNuevo}
            onToggle={() => setShowN((v) => !v)}
            hint={nuevo.length > 0 && nuevo.length < 6 ? 'Mínimo 6 caracteres' : undefined}
          />
          <Field
            label="Repetir nueva contraseña"
            value={confirmar}
            show={showN}
            onChange={setConfirmar}
            onToggle={() => setShowN((v) => !v)}
            hint={confirmar.length > 0 && confirmar !== nuevo ? 'No coincide' : undefined}
          />

          {err && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-white rounded-xl py-3.5 font-bold text-base"
          >
            {loading ? 'Guardando…' : 'Guardar nueva contraseña'}
          </button>
        </form>
      </main>
    </>
  );
}

function Field({
  label, value, show, onChange, onToggle, hint,
}: {
  label: string;
  value: string;
  show: boolean;
  onChange: (v: string) => void;
  onToggle: () => void;
  hint?: string;
}) {
  return (
    <div>
      <label className="block text-xs font-semibold mb-1.5" style={{ color: '#64748b' }}>
        {label}
      </label>
      <div className="relative">
        <input
          type={show ? 'text' : 'password'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete="new-password"
          placeholder="••••••••"
          className="w-full rounded-xl px-4 py-3 pr-12 text-sm outline-none"
          style={{ backgroundColor: '#ffffff', border: '1px solid #6e6b6b', color: '#303030' }}
        />
        <button
          type="button"
          onClick={onToggle}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-xl leading-none"
          tabIndex={-1}
        >
          {show ? '🐵' : '🙈'}
        </button>
      </div>
      {hint && <p className="text-xs text-red-500 mt-1">{hint}</p>}
    </div>
  );
}
